import { Skeleton, twMerge } from '@sortlist-frontend/design-system';

const KEY_POINTS = [0, 1, 2, 3, 4, 5];
const THEMES = [0, 1, 2];
const THEME_LINES = ['w-full', 'w-11/12', 'w-full', 'w-2/5'];

export const AiReviewSkeleton = () => (
  <div data-testid="review-summary-placeholder" className="flex flex-col gap-6">
    <div className="flex flex-wrap gap-2">
      {KEY_POINTS.map((key) => (
        <Skeleton key={key} className="h-6 w-16 rounded-full" data-testid="skeleton" />
      ))}
    </div>
    <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
      {THEMES.map((theme) => (
        <div key={theme} className="flex flex-col gap-2">
          <Skeleton className="h-3 w-3/5 rounded-md" />
          {THEME_LINES.map((width, index) => (
            <Skeleton key={index} className={twMerge('h-2 rounded-md', width)} />
          ))}
        </div>
      ))}
    </div>
  </div>
);
